import React, { useEffect, useRef, useState } from 'react';
import WaterLoader from './WaterLoader';
import { loaderBus } from '../utils/loaderBus';

// Full-screen water-drop overlay while any API request is in flight.
// Waits 350 ms before appearing so quick requests don't flicker.
const SHOW_DELAY_MS = 350;

const GlobalLoader = () => {
  const [visible, setVisible] = useState(false);
  const timer = useRef(null);

  useEffect(() => loaderBus.subscribe((pending) => {
    if (pending > 0) {
      if (!timer.current) timer.current = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    } else {
      clearTimeout(timer.current);
      timer.current = null;
      setVisible(false);
    }
  }), []);

  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-900/25 backdrop-blur-[1px]">
      <div className="bg-white/95 border border-slate-200 shadow-xl px-8 py-6">
        <WaterLoader label="Please wait…" />
      </div>
    </div>
  );
};

export default GlobalLoader;
